import { ReduxState } from '../../types'

export const getLoanRanges = (state: ReduxState) => state.codetable.loanRanges
